// extracted by mini-css-extract-plugin
export default {"wrapper":"Sidebar_wrapper__JRAQE","navWrapper":"Sidebar_navWrapper__shtl+","title":"Sidebar_title__J1gux"};